import * as Yup from 'yup';
import { PromoCodeType } from 'models/PromoCode';
import { OptionalObjectSchema } from 'yup/lib/object';

const addPromoCodeSchema = () => ({
  propertyUid: Yup.string().required(),
  singleUse: Yup.boolean().required(),
  name: Yup.string()
    .required()
    .matches(/[a-zA-Z0-9]+/),
  type: Yup.mixed<PromoCodeType>()
    .oneOf(Object.values(PromoCodeType))
    .required(),
  value: Yup.number().integer().required(),
  expirationDate: Yup.mixed().required(),
  validFromDate: Yup.mixed().required(),
  validToDate: Yup.mixed().required(),
});

export type AddPromoCodeFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof addPromoCodeSchema>>
>;

export default addPromoCodeSchema;
